// extracted by mini-css-extract-plugin
module.exports = {"list-translate":"_13939","form-item":"_13697","form-name":"_3190","form-input":"_13187","btn":"_2044","roundBtn":"_13403"};